import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { addCsrfHeader } from '../utils/csrfUtils';

export const useRefreshGroceryListIngredientQuantity = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { sessionToken } = useAuth();

    const refreshGroceryListIngredientQuantity = async (ingredientId, groceryListId, appUserId) => {

        console.log('refreshGroceryListIngredientQuantity hook running');

        try {
            setIsLoading(true);
            setError(null);

            if (!sessionToken) {
                throw new Error('No valid session found');
            }

            const headers = await addCsrfHeader({
                'Authorization': `Bearer ${sessionToken}`
            });

            const response = await fetch(`/api/v1/grocery-list-ingredient/refresh_grocery_list_ingredient_quantity/${ingredientId}/grocery_list/${groceryListId}/app_user/${appUserId}`, {
                method: 'POST',
                headers
            });

            if (!response.ok) {
                throw new Error('Failed to refresh grocery list ingredient quantity');
            }

            const data = await response.json();
            setIsLoading(false);
            return data;
        } catch (err) {
            setError(err.message);
            setIsLoading(false);
            throw err;
        }
    }

    return { refreshGroceryListIngredientQuantity, isLoading, error };
}

export default useRefreshGroceryListIngredientQuantity;
